import { createFileRoute, redirect } from '@tanstack/react-router';
import VenueDetailClient from '@/app/venues/[id]/venue-detail-client';
import { getSessionJwt } from '@/services/auth';

export const Route = createFileRoute('/venues/$venueId')({
  component: VenueDetail,
  beforeLoad: () => {
    if (!getSessionJwt()) {
      throw redirect({ to: '/login' });
    }
  },
});

function VenueDetail() {
  const { venueId } = Route.useParams();
  return <VenueDetailClient venueId={venueId} />;
}

